<template>
	<div class="fondoModal">
		<div>
			<div style="max-width:99%;">
				<div class="card">
					<div class="card-header">
						Editando producción
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<nueva-produccion :id-orden="idproduccion" @actualizar="emiteActualizar()"></nueva-produccion>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import NuevaProduccion from '../nueva/nueva'
import API from '../../services/api'

export default {
	name: 'editando-produccion',
	props: ['idproduccion'],
	components: {
		'nueva-produccion': NuevaProduccion
	},

	data: function () {
		return {
			produccion: null
		}
	},

	created () {
		// Descargamos los datos de la producción
		this.getProduccion()
	},

	methods: {
		getProduccion () {
			API.getProduccion(this.idproduccion)
				.then(res => {
					this.produccion = res.data.produccion
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		emiteActualizar () {
			this.$emit('actualizar')
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/editando-produccion.vue